import React from "react";
import { ExternalLink } from "@reverb-ui/icons-react";
import { Button, Flex, HStack, VStack, Text } from "@reverb-ui/react";
import { fontWeights, colors } from "@reverb-ui/tokens";
import { useTranslation } from "react-i18next";
export var ProductBox = function (_a) {
    var name = _a.name, icon = _a.icon, href = _a.href, description = _a.description;
    var t = useTranslation("home").t;
    return (React.createElement(Flex, { boxShadow: "md", bg: "white", borderRadius: 10, p: 5, w: "280px", minW: "280px", minH: "198px", flex: "true", flexDirection: "column", justifyContent: "space-between" },
        React.createElement(VStack, { spacing: 3, alignItems: "start", w: "full" },
            React.createElement(HStack, null,
                icon,
                React.createElement(Text, { fontSize: "lg", fontWeight: fontWeights.semibold }, name)),
            React.createElement(Text, { fontSize: "sm", color: colors.gray[600], noOfLines: 3 }, description)),
        React.createElement(Flex, { flexDirection: "row-reverse" },
            React.createElement(Button, { variant: "outline", rightIcon: React.createElement(ExternalLink, null), onClick: function () { return window.open(href, "_blank"); }, disabled: !href }, t("btn-open")))));
};
